<template>
  <div class="header text-left md:text-center mx-auto text-center">
    <TypeDisplay
      :variant="$options.Typography.Display.PETA"
      :weight="$options.Typography.Weights.STRONG"
      class="header-title mb-4"
    >
      <slot name="header" />
    </TypeDisplay>
    <TypeBody
      :variant="$options.Typography.Body.LARGE"
      :weight="$options.Typography.Weights.MEDIUM"
    >
      <slot name="subheader" />
    </TypeBody>
  </div>
</template>

<script>
import { constants, TypeBody, TypeDisplay } from '@bambeehr/pollen';
const { Typography } = constants;
export default {
  name: 'SectionHeader',
  Typography,
  components: {
    TypeBody,
    TypeDisplay,
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .header-title {
    font-size: 28px;
    line-height: 36px;
  }
}
</style>
